
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intl",
      function () {
        return require("private-next-pages/intl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intl"])
      });
    }
  